module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-add-b2b3b2c6bf2ba940d3e186fae964b947.svg";